/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface ActivityDto
 */
export interface ActivityDto {
    /**
     * Activity ID
     * @type {string}
     * @memberof ActivityDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof ActivityDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof ActivityDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof ActivityDto
     */
    'deletedAt': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'source': ActivityDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof ActivityDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof ActivityDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof ActivityDto
     */
    'type': ActivityDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof ActivityDto
     */
    'activityDate': string;
    /**
     * User ID who performed the activity
     * @type {string}
     * @memberof ActivityDto
     */
    'userId': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof ActivityDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Array of participation IDs that this activity was submitted to
     * @type {Array<string>}
     * @memberof ActivityDto
     */
    'participationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was approved for
     * @type {Array<string>}
     * @memberof ActivityDto
     */
    'approvedParticipationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was declined for
     * @type {Array<string>}
     * @memberof ActivityDto
     */
    'declinedParticipationRecords': Array<string>;
    /**
     * User who performed the activity
     * @type {UserDto}
     * @memberof ActivityDto
     */
    'user': UserDto;
}

export const ActivityDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type ActivityDtoSourceEnum = typeof ActivityDtoSourceEnum[keyof typeof ActivityDtoSourceEnum];
export const ActivityDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type ActivityDtoTypeEnum = typeof ActivityDtoTypeEnum[keyof typeof ActivityDtoTypeEnum];


